import { mapTokenToUser, persistUser } from "../../../utils/persist";

// Persists the signed-in user from the OIDC access token and returns it.
export class LoginCommand {
  constructor(token) {
    this.token = token;
  }

  execute() {
    const user = { ...mapTokenToUser(this.token), sessionStart: Date.now() };
    persistUser(user);
    return user;
  }
}
